"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var material_1 = require("@mui/material");
var makeRadioButtonStyling = function (smallIcon, minHeight) {
    var _a, _b;
    var _c = (0, react_1.useTheme)(), breakpoints = _c.breakpoints, mvf = _c.mvf;
    var spacing = mvf.spacing, fontSize = mvf.fontSize, palette = mvf.palette;
    return {
        radio: (0, react_1.css)({
            color: palette.component.answerUnselectedColor,
            '&.MuiIconButton-root': {
                '@media (hover: hover)': {
                    '&:hover': {
                        backgroundColor: (0, material_1.alpha)(palette.component.answerSelectedColor, 0.04),
                    },
                },
            },
            '&.MuiRadio-root': (_a = {
                    paddingLeft: 11,
                    paddingRight: 11
                },
                _a[breakpoints.up('tabletSmall')] = {
                    paddingLeft: 11,
                    paddingRight: 11,
                    marginLeft: 11,
                },
                _a),
        }),
        grid: (0, react_1.css)({
            height: '100%',
            width: '100%',
            minHeight: minHeight ? minHeight : 48,
        }),
        icon: (0, react_1.css)({
            marginTop: smallIcon ? 14 : 9,
            marginBottom: smallIcon ? 14 : 9,
            width: smallIcon ? 60 : 100,
            '& img': {
                height: smallIcon ? 30 : 40,
            },
        }),
        imgDiv: (0, react_1.css)({
            display: 'flex',
            justifyContent: 'center',
        }),
        innerGrid: (0, react_1.css)({
            flexWrap: 'nowrap',
        }),
        textGrid: (0, react_1.css)({
            overflowWrap: 'anywhere',
            wordBreak: 'normal',
            justifyContent: 'flex-start',
            width: '85%',
        }),
        otherInput: (0, react_1.css)({
            marginTop: -1,
            marginRight: spacing.medium,
            padding: spacing.tiny,
            '& .MuiInputBase-root input': (_b = {
                    textAlign: 'left',
                    fontSize: fontSize.mini
                },
                _b[breakpoints.up('mobileMedium')] = {
                    fontSize: fontSize.small,
                },
                _b[breakpoints.up('tabletSmall')] = {
                    fontSize: fontSize.compact,
                },
                _b),
        }),
    };
};
exports.default = makeRadioButtonStyling;
//# sourceMappingURL=makeRadioButtonStyling.js.map